export enum ProductSavingPlanType {
  Saver = 'saver',
  Standard = 'standard',
  Suite = 'suite',
}
